import { IGetContratoDropDownUseCase } from "../../../presentation/useCases/read/get_contrato_drop_down_use_case";
import { ContratoDropDown } from "../../models/contrato_dropdown";
import { ICommonsRepository } from "../../repositories/commons_repository";

/**
 * GetContratoDropDownUseCase
 */

export class GetContratoDropDownUseCase implements IGetContratoDropDownUseCase {
  constructor(private readonly repository: ICommonsRepository) { }

  async getContratoDropDown(): Promise<ContratoDropDown[]> {
    return await this.repository.getContratoDropDown();
  }
}
